define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/heading/SelectController",
	"csi/service/writerService",
	"csi/xml"
], function(declare, _, SelectController, {writeAggregateStoreOperation}, xml) {

	return declare(SelectController, {
		/** @property {Names} enumAggregateStore - aggregate store used for enum */
		enumAggregateStore: null,

		/**
		 * @override
		 * Ensure that old value is the blank enum if empty
		 */
		getOldValue() {
			const v = this.inherited(arguments);
			return v || xml.enumCreate(this.heading.m_format);
		},

		/**
		 * @override
		 * Track aggregate store
		 */
		_toHtmlDynamic(ctx, params) {
			const editNode = this.inherited(arguments);
			const store = editNode.get("store");

			this.enumAggregateStore = store;

			return editNode;
		},

		/**
		 * @override
		 * Change enum value and any dependents
		 */
		_toWriterAttribute(id, type) {
			const {enumAggregateStore, heading, newValue, m_writer} = this;

			if (enumAggregateStore?.aggregateStoreResponse) {
				writeAggregateStoreOperation(m_writer, enumAggregateStore.aggregateStoreResponse, [].concat(newValue));

				// trigger any watchAttribute function for attribute
				this._notifyOfChange(null, this.getNode(), heading.m_id);
			} else {
				// if renderer overridden in Site.js to use old enum store, then use old publish behavior
				// NOTE: this will not work with dependent enums
				this.inherited(arguments);
			}
		},

		/** React */

		/**
		 * Retrieve values which are already in memory to create placeholder in inline control
		 * @returns {SelectOptions}
		 */
		getReactPlaceholderOptions() {
			const {heading, ren} = this;
			const selectOptions = ren.getReactPlaceholderOptions(this, this.getContext(), heading);

			this.enumAggregateStore = selectOptions.store;

			return selectOptions;
		}
	});
});